import { Component } from '@angular/core';

@Component({
  selector: 'si-bulk-upload',
  standalone: true,
  imports: [],
  templateUrl: './bulk-upload.component.html',
  styleUrl: './bulk-upload.component.scss'
})
export class BulkUploadComponent {

}
